import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { 
  ArrowRight, 
  CheckCircle, 
  // Sparkle 
} from "@phosphor-icons/react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const HrRegistration = () => {
  const location = useLocation();
  const [submitted, setSubmitted] = useState(false);
  const [surveyCompleted, setSurveyCompleted] = useState(false);

  const [formData, setFormData] = useState({
    companyName: "",
    email: "",
    phone: "",
    employees: "",
  });

  useEffect(() => {
    if (location.state) {
      const { employees, surveyCompleted: isCompleted } = location.state as { 
        employees?: string; 
        surveyCompleted?: boolean 
      };
      
      if (isCompleted) {
        setSurveyCompleted(true);
      }

      if (employees) {
        // Map survey options to select box options if necessary
        let mappedEmployees = employees;
        if (employees === "1-49") mappedEmployees = "1-10"; // or closest match
        else if (employees === "50-99") mappedEmployees = "51-200";
        else if (employees === "100-499") mappedEmployees = "201-500";
        else if (employees === "500+") mappedEmployees = "500+";

        setFormData((prev) => ({
          ...prev,
          employees: mappedEmployees,
        }));
      }
    }
  }, [location.state]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Mock submission
    console.log("Submitted HR Registration:", formData);
    setSubmitted(true);
  };

  return (
    <div className="bg-gray-50 min-h-screen text-gray-800 flex flex-col">
      <Navbar />

      <main className="flex-1 px-6 py-16 md:px-16 lg:px-24 bg-gradient-to-b from-visaro-orange-15 via-white to-gray-50 flex items-center justify-center">
        <div className="max-w-xl w-full bg-white rounded-3xl border border-gray-200 shadow-sm p-8 md:p-12">
          {!submitted ? (
            <>
              <div className="mb-8 text-center">
                {surveyCompleted && (
                  <>
                  {/* <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-visaro-visaGreen/20 text-visaro-visaGreen text-xs font-bold mb-4 border border-visaro-visaGreen/30">
                    <Sparkle weight="fill" className="w-3.5 h-3.5" />
                    <span>Survey Completed — Portal Setup Customizing</span>
                  </div> */}
                  </>
                )}
                <h1 className="text-3xl font-bold text-deepBlue mb-3">Claim Your Free HR Portal</h1>
                <p className="text-gray-600">
                  Register your company below to get access to instant Credit on Request, salary advances, and seamless employee management.
                </p>
              </div>

              <form onSubmit={handleSubmit} className="flex flex-col gap-5">
                <div>
                  <label htmlFor="companyName" className="block text-sm font-medium text-gray-700 mb-1">
                    Company Name
                  </label>
                  <input
                    type="text"
                    id="companyName"
                    name="companyName"
                    required
                    value={formData.companyName}
                    onChange={handleChange}
                    className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:outline-none focus:ring-2 focus:ring-visaro-orange focus:border-transparent transition-all"
                    placeholder="e.g. Visaro Tech Ltd."
                  />
                </div>

                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
                    Work Email
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    required
                    value={formData.email}
                    onChange={handleChange}
                    className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:outline-none focus:ring-2 focus:ring-visaro-orange focus:border-transparent transition-all"
                    placeholder="hr@yourcompany.com"
                  />
                </div>

                <div>
                  <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1">
                    Phone Number
                  </label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    required
                    value={formData.phone}
                    onChange={handleChange}
                    className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:outline-none focus:ring-2 focus:ring-visaro-orange focus:border-transparent transition-all"
                    placeholder="+234 800 000 0000"
                  />
                </div>

                <div>
                  <label htmlFor="employees" className="block text-sm font-medium text-gray-700 mb-1">
                    Number of Employees
                  </label>
                  <select
                    id="employees"
                    name="employees"
                    required
                    value={formData.employees}
                    onChange={handleChange}
                    className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:outline-none focus:ring-2 focus:ring-visaro-orange focus:border-transparent transition-all bg-white"
                  >
                    <option value="" disabled>Select an option</option>
                    <option value="1-10">1-10</option>
                    <option value="11-50">11-50</option>
                    <option value="51-200">51-200</option>
                    <option value="201-500">201-500</option>
                    <option value="500+">500+</option>
                  </select>
                </div>

                <button
                  type="submit"
                  className="mt-4 w-full flex items-center justify-center gap-2 bg-deepBlue text-white py-4 rounded-xl font-bold hover:bg-opacity-90 transition-opacity"
                >
                  Submit Registration
                  <ArrowRight weight="bold" />
                </button>
              </form>
            </>
          ) : (
            <div className="text-center py-10 flex flex-col items-center gap-4">
              <div className="text-visaro-orange mb-2">
                <CheckCircle size={64} weight="fill" />
              </div>
              <h2 className="text-3xl font-bold text-deepBlue">Registration Received!</h2>
              <p className="text-gray-600 mb-6">
                Thank you for your interest. Our team will contact you shortly to set up your free HR portal.
              </p>
              <button
                onClick={() => window.location.href = "/"}
                className="inline-flex items-center gap-2 border border-gray-300 bg-white text-deepBlue py-3 px-6 rounded-xl font-bold hover:bg-gray-50 transition-colors"
              >
                Return to Homepage
              </button>
            </div>
          )}
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default HrRegistration;
